<template>
  <div v-if="start">
    <div class="lg:w-3/4">
      <vx-card class="lg:p-8 w-full mb-6">
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input
              class="w-full"
              label="Имя: *"
              name="first_name"
              v-model="currentSettings.firstName"
              v-validate="'required'"
              :class="isEditedClass(currentSettings.firstName, settings.firstName)" />
            <span class="text-danger text-sm" v-show="errors.has('first_name')">{{ errors.first('first_name') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input
              class="w-full"
              label="Фамилия:"
              name="last_name"
              v-model="currentSettings.lastName"
              :class="isEditedClass(currentSettings.lastName, settings.lastName)" />
            <span class="text-danger text-sm" v-show="errors.has('last_name')">{{ errors.first('last_name') }}</span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <UploadFile
              v-model="currentSettings.profile_image_key"
              :class="isEditedClass(currentSettings.profile_image_key, settings.profile_image_key)"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <password-input
              label="Пароль:"
              name="password"
              v-model="currentSettings.password"
              v-validate="'min:8'"
              ref="password"
              class="w-full"
              :class="isEditedClass(currentSettings.password, settings.password)" />
            <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <password-input
              label="Подтвердить пароль:"
              name="password_confirmation"
              v-model="password_confirmation"
              data-vv-as="password"
              v-validate="'confirmed:password'"
              class="w-full" />
            <span class="text-danger text-sm" v-show="errors.has('password_confirmation')">{{ errors.first('password_confirmation') }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <div class="flex items-center">
              <vs-switch
                v-model="currentSettings.settings['notifications.enabled']"
                :class="isEditedClass(currentSettings.settings['notifications.enabled'], settings.settings['notifications.enabled'])"
                @change="checkNotifications"
              />
              <span class="ml-2">Включить уведомления</span>
            </div>
          </div>
        </div>
      </vx-card>

      <SaveBlock
        :show="hasChanges"
        :loading="loading"
        @accept="handleSave"
        @cancel="handleCancel"
      />
    </div>
  </div>
</template>

<script>
import { isEditedClass, mergeDeep, compareObjects, copyObject } from '../../helpers/helpers'
import { mapGetters, mapActions } from 'vuex'

import Auth from '../../api/http/models/auth/Auth'
import AuthUpdatePayloadCast from '../../api/http/models/auth/AuthUpdatePayloadCast'

export default {
  data () {
    return {
      start: false,
      hasChanges: false,
      loading: false,
      password_confirmation: '',
      currentSettings: {
        settings: {}
      },
      settings: {
        ...copyObject(AuthUpdatePayloadCast),
        firstName: '',
        lastName: ''
      }
    }
  },

  computed: {
    ...mapGetters(['authUser']),
    name () {
      return `${this.firstName} ${this.lastName}`
    }
  },

  watch: {
    currentSettings: {
      deep: true,
      handler (newValue) {
        this.hasChanges = !compareObjects(newValue, this.settings)
      }
    }
  },

  created () {
    this.setData()
    this.start = true
    this.checkNotifications()
  },

  methods: {
    ...mapActions(['updateUser']),

    isEditedClass,

    setData () {
      [this.settings.firstName, this.settings.lastName] = `${this.authUser.name} `.split(' ')
      this.settings = mergeDeep(this.settings, this.authUser)
      this.currentSettings = copyObject(this.settings)
      this.password_confirmation = ''
    },

    async handleSave () {
      this.loading = true
      let validate = false
      validate = await this.$validator.validateAll()
      if (this.currentSettings.password !== '' && this.password_confirmation === '') {
        validate = false
        this.$validator.errors.add({
          field: 'password_confirmation',
          msg: 'Повторите пароль'
        })
      }
      if (validate) {
        this.currentSettings.name = `${this.currentSettings.firstName} ${this.currentSettings.lastName}`.trim()
        const response = await Auth.update(this.currentSettings)
        if (response.status === 'success') {
          this.updateUser(response.data)
        }
        this.setData()
      }
      this.loading = false
    },

    handleCancel () {
      this.setData()
    },

    checkNotifications () {
      if (this.currentSettings.settings['notifications.enabled']) {
        if (Notification.permission !== 'granted') {
          Notification.requestPermission(permission => {
            this.currentSettings.settings['notifications.enabled'] = permission === 'granted'
          })
        }
      }
    }
  }
}
</script>
